import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "consent_banner mt_1" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row mx_0_5" }
const _hoisted_4 = { class: "col px_1 pt_1" }
const _hoisted_5 = { class: "row mx_0_5" }
const _hoisted_6 = { class: "col_12 col_sm_6 px_1 pb_1 pt_0_5" }
const _hoisted_7 = { class: "col_12 col_sm_6 px_1 pb_1 pt_sm_0_5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", null, [
            _cache[3] || (_cache[3] = _createElementVNode("span", { class: "text_b" }, "Einbindung externer Inhalte", -1)),
            _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
            _cache[5] || (_cache[5] = _createTextVNode(" Auf dieser Website sind Inhalte von YouTube und Google Maps eingebettet. Diese werden erst geladen, wenn du zustimmst. Dabei können personenbezogene Daten an die jeweiligen Anbieter übermittelt werden. Mehr Infos findest du in unserer ")),
            _createVNode(_component_router_link, {
              to: { name: 'datenschutz' },
              class: "link"
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("Datenschutzerklärung")
              ])),
              _: 1
            }),
            _cache[6] || (_cache[6] = _createTextVNode(".")),
            _cache[7] || (_cache[7] = _createElementVNode("br", null, null, -1)),
            _cache[8] || (_cache[8] = _createTextVNode(" Möchtest du die Inhalte aktivieren? "))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { active: _ctx.consentStatus === 'accepted' }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.acceptConsent && _ctx.acceptConsent(...args)))
          }, " Ja, Inhalte laden " + _toDisplayString(_ctx.consentStatus === 'accepted' ? '(gewählt)' : ''), 3)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", { active: _ctx.consentStatus === 'rejected' }]),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rejectConsent && _ctx.rejectConsent(...args)))
          }, " Nein, Inhalte blockieren " + _toDisplayString(_ctx.consentStatus === 'rejected' ? '(gewählt)' : ''), 3)
        ])
      ])
    ])
  ]))
}